import styles from "./TrainModel.module.scss";
import { useTrainingTasks } from "./useTrainingTasks";
import { TrainingStatusView } from "./TrainingStatusView";
import PauseIcon from "../../../../assets/icons/PauseIcon";
import { TrainingTask } from "../../../../vl-api/vlSchemas";

export const TrainingStatus = ({
  task,
  handleCancelTaskClick,
  handleCompletedClick,
}: Pick<ReturnType<typeof useTrainingTasks>, "handleCancelTaskClick"> & {
  task: TrainingTask;
  handleCompletedClick: () => void;
}) => (
  <>
    {task.status === "INIT" && <InitView />}
    {task.status === "FAILED" && <FailedView error={task.error} />}
    {task.status === "COMPLETED" && (
      <CompletedView handleCompletedClick={handleCompletedClick} />
    )}
    {task.status === "CANCELLED" && <CanceledView />}
    {task.status === "IN_PROGRESS" && (
      <InProgressView
        progress={task.progress!}
        taskId={task.id}
        handleCancelTask={handleCancelTaskClick}
      />
    )}
  </>
);

const InitView = () => (
  <TrainingStatusView status="INIT" text="Initializing Training" />
);

const InProgressView = ({
  progress,
  taskId,
  handleCancelTask,
}: {
  progress: number;
  taskId: string;
  handleCancelTask: (id: string) => void;
}) => (
  <TrainingStatusView
    status="IN_PROGRESS"
    text={`${Math.floor(progress * 100)}% Training`}
    action={
      <PauseIcon
        className={styles.cancelIcon}
        onClick={() => handleCancelTask(taskId)}
      />
    }
  />
);

const CompletedView = ({
  handleCompletedClick,
}: {
  handleCompletedClick: () => void;
}) => (
  <TrainingStatusView
    status="COMPLETED"
    text="Training Completed"
    onClick={handleCompletedClick}
  />
);

const FailedView = ({ error }: { error: TrainingTask["error"] }) => {
  return (
    <TrainingStatusView
      status="FAILED"
      text="Training Failed"
      tooltip={
        <>
          {Object.entries(error as any).map(([key, value]) => (
            <>
              <span>{key}:</span>
              <span>{String(value)}</span>
            </>
          ))}
        </>
      }
    />
  );
};

const CanceledView = () => (
  <TrainingStatusView status="CANCELLED" text="Training Canceled" />
);
